import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import type { IconName } from '../../common/icon/icons.type';
import { PreventOrphansPipe } from '../../pipes/prevent-orphans.pipe';
import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';
import { IconComponent } from '../icon/icon.component';
import { IconContainerComponent } from '../icon-container/icon-container.component';

@Component({
  selector: 'rt-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.min-height.rem]': 'resolveMinHeight(minHeight())',
    '[class.no-content-margin]': '!hasContentMargin()',
    '[class]': 'variant()',
  },
  imports: [IconComponent, NgStyle, PreventOrphansPipe, IconContainerComponent],
})
export class EmptyStateComponent {
  public static readonly DEFAULT_MIN_HEIGHT = 22;
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'small',
      'v-centered',
      'with-padding-top',
      'heading-large-x',
      'heading-margin-top-small',
    ],
  ];

  public readonly variant = input(...ComponentVariantTransform(EmptyStateComponent.VARIANTS));
  public readonly minHeight = input<boolean | number>(false);
  public readonly hasContentMargin = input<boolean>(true);
  public readonly fixedImageDimensions = input<{
    width: string;
    height: string;
  }>();
  @Input() public title: string;
  @Input() public titleIcon: IconName;
  @Input() public desc: string;
  @Input() public icon: IconName | null;
  @Input() public imageUrl: string | null;

  public resolveMinHeight(minHeight: boolean | number): null | number {
    return minHeight === true
      ? EmptyStateComponent.DEFAULT_MIN_HEIGHT
      : typeof minHeight === 'number'
        ? minHeight
        : null;
  }
}
